import { render, staticRenderFns } from "./AddMediaComp.vue?vue&type=template&id=02853d78&scoped=true"
import script from "./AddMediaComp.vue?vue&type=script&lang=js"
export * from "./AddMediaComp.vue?vue&type=script&lang=js"
import style0 from "./AddMediaComp.vue?vue&type=style&index=0&id=02853d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02853d78",
  null
  
)

export default component.exports